export default {
  level: 0,
  user_id: null,
  email: null,
  access_key: null,

  update: {
    old_password: '',
    new_password: '',
    retype_password: '',
  },

  forgot: {
    email: '',
  },

  regist: {
    email: '',
    code: '',
    password: '',
    retype_password: '',
    policy: false,
  },
};
